import React from 'react';
import useParallaxEffect from '../../hooks/useParallaxEffect';
import './index.css';

const ParallaxContainer: React.FC = () => {
  useParallaxEffect();

  return (
    <div className="parallax-container">
      <div className="logo">
        <img
          src="/img/logos/t2consult-header-logo.png"
          alt="t2consult Logo"
        />
      </div>
      <div className="triangle triangle1" />
      <div className="triangle triangle2" />
      <div className="triangle triangle3" />
      <div className="triangle triangle4" />
      <div className="triangle triangle5" />
      <div className="triangle triangle6" />
    </div>
  );
};

export default ParallaxContainer;
